/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './custom-event-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-custom-event-list-page',
  template
})
export class CustomEventListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.adm.custom-events.custom-event';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {param: 'id'},
    {param: 'valueType'},
    {param: 'conversionType'},
    {param: 'type'},
    {param: 'priority'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
